// @flow

import * as React from "react";
import _ from "lodash";

type FakeDomRectType = {
    x: number,
    y: number,
    width: number,
    height: number,
};

/** Returns the boundling client rect for the passed in element - updates on a throttled window.resize event (defaults to 100ms throttle) */
const useBoundingClientRect = (
    ref: any,
    didResize: (rect: FakeDomRectType) => void = () => {},
    throttleInMs: number = 100
): FakeDomRectType => {
    const [domRect, setDomRect] = React.useState<FakeDomRectType>({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    });

    const update = () => {
        if (ref.current) {
            const newDomRect: FakeDomRectType = {
                x: ref.current.clientLeft,
                y: ref.current.clientTop,
                width: ref.current.clientWidth,
                height: ref.current.clientHeight,
            };
            setDomRect(newDomRect);
            didResize(newDomRect);
        }
    };
    const throttled = React.useRef(_.throttle(update, throttleInMs)).current;

    React.useEffect((): any => {
        if (throttled) {
            throttled();
            window.addEventListener("resize", throttled);
            return () => {
                window.removeEventListener("resize", throttled);
            };
        }
    }, [throttled]);
    //}, [ref.current, throttled]);

    return domRect;
};

export default useBoundingClientRect;
